import React from 'react';
import { useTheme } from '../hooks/useTheme';

const AGENT_COLORS = {
  PM: '#6366f1',
  ARCHITECT: '#8b5cf6',
  DEVELOPER: '#3b82f6',
  VALIDATOR: '#10b981',
  QA: '#f59e0b',
  DEBUGGER: '#ef4444',
  DEVOPS: '#06b6d4',
  TEST: '#84cc16',
  SANDBOX: '#64748b',
  DEPLOY: '#f97316',
  INSTALL: '#a855f7',
  BUILD: '#0ea5e9',
  RUNTIME: '#dc2626',
};

function hexToRgb(hex) {
  const cleaned = hex.replace('#', '');
  if (cleaned.length === 3) {
    const r = parseInt(cleaned[0] + cleaned[0], 16);
    const g = parseInt(cleaned[1] + cleaned[1], 16);
    const b = parseInt(cleaned[2] + cleaned[2], 16);
    return { r, g, b };
  }
  const r = parseInt(cleaned.slice(0, 2), 16);
  const g = parseInt(cleaned.slice(2, 4), 16);
  const b = parseInt(cleaned.slice(4, 6), 16);
  return { r, g, b };
}

function darkenHex(hex, factor = 0.45) {
  const { r, g, b } = hexToRgb(hex);
  const clamp = (n) => Math.max(0, Math.min(255, Math.round(n * factor)));
  return `rgb(${clamp(r)}, ${clamp(g)}, ${clamp(b)})`;
}

function getReadableTextColor(hex) {
  const { r, g, b } = hexToRgb(hex);
  const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  return luminance > 0.6 ? '#0f172a' : '#ffffff';
}

export default function AgentBadge({ agent }) {
  const { mode } = useTheme();
  const normalized = (agent || 'SANDBOX').toString().toUpperCase();
  const color = AGENT_COLORS[normalized] || AGENT_COLORS.SANDBOX;
  const { r, g, b } = hexToRgb(color);

  const isLight = mode === 'light';
  const textColor = isLight ? darkenHex(color, 0.42) : getReadableTextColor(color);
  const background = isLight ? `rgba(${r}, ${g}, ${b}, 0.14)` : `${color}22`;
  const border = isLight ? `rgba(${r}, ${g}, ${b}, 0.38)` : `${color}55`;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        padding: '2px 8px',
        borderRadius: 999,
        border: `1px solid ${border}`,
        background,
        color: textColor,
        fontSize: 10,
        fontWeight: 800,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        fontFamily: "'JetBrains Mono', monospace",
      }}
      aria-label={`Agent ${normalized}`}
    >
      [{normalized}]
    </span>
  );
}

export { AGENT_COLORS };

